import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { SetCertification } from '../AppActionTypes';

export interface SetCertificationAction extends Action {
  item: IContentInfo<'database'> | IContentInfo<'table'> | IContentInfo<'datasource'>;
}

export function setCertificationAction(item: SetCertificationAction['item']): SetCertificationAction {
  return {
    type: SetCertification,
    item
  };
}
